import Entity from '../entity'

export default class CouponTransfer extends Entity<number>{
    isUse:boolean=false;
    user:any;
    coupon:any;
}
